import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/allocations": [6],
		"/allocations/execute": [7],
		"/auth/login": [8],
		"/customers": [9],
		"/customers/create": [12],
		"/customers/[id]": [10],
		"/customers/[id]/edit": [11],
		"/home": [13],
		"/inventories/adjustments": [14],
		"/inventories/stocktaking": [15],
		"/inventories/stocktaking/new": [17],
		"/inventories/stocktaking/[id]": [16],
		"/inventory-receipts": [20],
		"/inventory-receipts/approve": [23],
		"/inventory-receipts/create": [24],
		"/inventory-receipts/[id]": [21],
		"/inventory-receipts/[id]/edit": [22],
		"/inventory-valuations": [25],
		"/inventory": [18],
		"/inventory/[id]": [19],
		"/orders": [26],
		"/picking/[id]": [27],
		"/poc-prototypes/complex-form-sample": [28],
		"/poc-prototypes/picking-atoms": [30],
		"/poc-prototypes/picking": [29],
		"/products": [31],
		"/products/create": [35],
		"/products/[id]": [32],
		"/products/[id]/barcodes": [33],
		"/products/[id]/edit": [34],
		"/purchase-orders": [36],
		"/purchase-orders/create": [39],
		"/purchase-orders/[id]": [37],
		"/purchase-orders/[id]/edit": [38],
		"/sales-orders": [40],
		"/sales-orders/create": [43],
		"/sales-orders/import/amazon-vendor": [44],
		"/sales-orders/[id]": [41],
		"/sales-orders/[id]/edit": [42],
		"/settings": [45,[2]],
		"/settings/additional-attributes": [46,[2]],
		"/settings/billing": [47,[2]],
		"/settings/carriers": [48,[2]],
		"/settings/manufacturers": [49,[2]],
		"/settings/product-categories": [50,[2]],
		"/settings/product-series": [51,[2]],
		"/settings/warehouse-locations": [52,[2]],
		"/shipments": [53],
		"/shipments/export-instruction": [56],
		"/shipments/picking": [57],
		"/shipments/[id]": [54],
		"/shipments/[id]/confirm": [55],
		"/signup": [58,[3]],
		"/signup/payment": [59,[3]],
		"/signup/status": [60,[3]],
		"/signup/verify": [61,[3]],
		"/[tenant_code]/auth/login": [5]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';